// extracted by mini-css-extract-plugin
module.exports = {"produceTb":"userInfo_produceTb__XtgY-","checkBoxForm":"userInfo_checkBoxForm__1HJqf","notiRcpmsgTm":"userInfo_notiRcpmsgTm__1leD4"};